import { Modal, ModalBody } from "reactstrap";
import CreateUserForm from "../form/CreateUserForm";
import { modalZIndex } from "../../utils/UiUtils";

function CreateUserModal({ isOpen, toggle }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={"lg"}
      backdrop={"static"}
      zIndex={modalZIndex()}
    >
      <ModalBody>
        <CreateUserForm close={toggle} />
      </ModalBody>
    </Modal>
  );
}

export default CreateUserModal;
